import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';

@Component({
  selector: 'app-bba-computer-applications',
  templateUrl: './bba-computer-applications.component.html',
  styleUrls: ['./bba-computer-applications.component.scss']
})
export class BbaComputerApplicationsComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
